<template>
	<div>
		<form class="form-container" @submit.prevent="updateDetails">
			<input 
				placeholder="Contact number" 
				v-model="contact_no" 
				type="text" 
				name="contact_no"
				oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
				maxlength="22" 
				:class="{ error: $v.contact_no.$error }"
				@blur="$v.contact_no.$touch()" 
				value />
			<template v-if="$v.contact_no.$error">
				<p v-if="!$v.contact_no.required" class="errorMessage">
				{{ $t('contactNoReq') }}
				</p>
			</template>
			<button 
				class="add-btn" 
				type="submit"
				:disabled="$v.$invalid" 
				name="button">
				{{ $t('save') }}
			</button>
			<ul>
				<li v-for="(error, index) in errors" :key="index">{{ error }}</li>
			</ul>
		</form>
	</div>
</template>

<script>
import { required} from 'vuelidate/lib/validators'


export default {
	data() {
		return {
		contact_no: this.contact,
		errors: null
		}
	},
	props: {
		contact: String
	},
	validations: {
    	contact_no: { required },
  	},
	methods: {
		updateDetails() {
		this.$store
			.dispatch('cleaner/editCleaner', {
			contact_no: this.contact_no
			})
			.then(async () => {
			await this.$store.dispatch('cleaner/fetchCleanerDetails')
			this.$emit('update-success', true)
			})
			.catch(err => {
			this.errors = err.response.data.errors
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.form-container {
	//position: absolute;
	background: #fff;
	padding: 30px;
	border-radius: 10px;
	box-shadow: 0px 0px 8px 0px #000;
}

a:visited {
	color: #2c3e50;
}

.add-btn {
	background: var(--primary);
	color: var(--bright);
	padding: 0.3em;
	letter-spacing: 3px;
	width: 80%;
}

.button,
button {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 5px;
	background: linear-gradient(to right, $secondary, $secondary-dark);
	font-size: 1.5em;
	color: white;
	border: none;
	text-transform: uppercase;
	letter-spacing: 0.15em;
	outline: none;
}

button:disabled,
button[disabled]{
	border: 1px solid #999999;
	background-color: #cccccc;
	color: #666666;
	cursor: context-menu;
}

form {
	display: flex;
	align-items: center;
	flex-direction: column;

	p {
		color: red;
	}
}

input {
	display: block;
	box-sizing: border-box;
	border-style: solid;
	width: 100%;
	height: 2.6em;
	padding: 0.5em;
	margin-bottom: 1em;
	font: 1em 'Lato', Helvetica, sans-serif;
}
.errorMessage {
	font-size: 0.8em;
	margin-top: -10px;
	color: var(--primaryDark);
}

h1 {
	margin-top: 0;
}
</style>
